import PropTypes from 'prop-types';

import { Skeleton } from '@ctct/ui-react';

import Price from './Price';
import { getIntegerDecimalsFromPrice } from '../../../FeatureUpgradeDialog/utils/currencyUtil';

const PriceContainer = ({ price }) => {
  const { paymentPeriodLabel, planCurrency, planFullPrice, planPriceDiscounted, isUpdatingCurrency, showDecimals } =
    price;

  const currencySymbol = planCurrency;

  const showCrossedPrice = planPriceDiscounted != null;
  const [integer, decimals] = getIntegerDecimalsFromPrice(planPriceDiscounted ?? planFullPrice);
  const [crossedInteger, crossedDecimals] = getIntegerDecimalsFromPrice(planFullPrice);

  if (isUpdatingCurrency) {
    return (
      <div className="price-container">
        <div className="main-price-container">
          <Skeleton variant="rectangular" width={50} height={30} />
        </div>
      </div>
    );
  }

  return (
    <div className="price-container">
      <Price
        currencySymbol={currencySymbol}
        integer={integer}
        decimals={decimals}
        showDecimals={showDecimals}
        paymentPeriodLabel={paymentPeriodLabel}
      />

      {showCrossedPrice && (
        <Price
          size="sm"
          crossed
          inlineCurrency
          currencySymbol={currencySymbol}
          integer={crossedInteger}
          decimals={crossedDecimals}
          showDecimals={showDecimals}
        />
      )}
    </div>
  );
};

PriceContainer.propTypes = {
  price: PropTypes.shape({
    paymentPeriodLabel: PropTypes.string.isRequired,
    planCurrency: PropTypes.string.isRequired,
    planFullPrice: PropTypes.number.isRequired,
    planPriceDiscounted: PropTypes.number,
    isUpdatingCurrency: PropTypes.bool.isRequired,
    showDecimals: PropTypes.bool.isRequired,
  }).isRequired,
};

export default PriceContainer;
